import { Box } from "@mui/material"
import BottomSection from "./BottomSection"
import { Page_Padding } from "../../shared/constants"
import ParentTrustLataaSection from "./ParentTrustLataaSection"
import CustomDivider from "../../shared/utils/CustomDivider"
import OurApproachSection from "./OurApproachSection"
import HowWorkSection from "./HowWorkSection"
import HeroSection from "./HeroSection"
import { usePageContentWithMeta } from "../../shared/hook/usePageContentWithMeta"
import { useEffect } from "react"


const AiEdge = ({ onLoadingChange = () => { } }) => {
    const { data: Detail, isLoading } = usePageContentWithMeta("AI_EDGE");
    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);
    if (isLoading) return null;
    return (
        <Box className="body contact_us">
            <HeroSection bottomData={Detail?.content[1]?.data} heroData={Detail?.content[0]?.data} />
            <Box px={Page_Padding}>
                <CustomDivider />
                <HowWorkSection howWorkData={Detail?.content[2]?.data} />
                <CustomDivider />
                <OurApproachSection approachesData={Detail?.content[3]?.data} />
                <CustomDivider />
                <ParentTrustLataaSection parentTrustData={Detail?.content[4]?.data} />
                <CustomDivider />
                <BottomSection bottomData={Detail?.content[5]?.data} />

            </Box>


        </Box>
    )
}

export default AiEdge



